import { useEffect } from "react";
import { useAuthStore } from "../store";
import socket from "../Utils/socketClient";

const SocketSync = () => {
  useEffect(() => {
    socket.on("teamDetailsTrigger", (timeStamp) => {
      // console.log("📥 Received: teamDetailsTrigger", timeStamp);
      useAuthStore.setState({ teamDetailsTrigger: timeStamp });
    });

    socket.on("selectedPlayerData", (data) => {
      // console.log("📥 Received: selectedPlayerData", data || "no name");
      useAuthStore.setState({ selectedPlayerData: data });
    });

    socket.on("clearSelectedPlayerData", () => {
      // console.log("📥 Received: clearSelectedPlayerData");
      useAuthStore.setState({ selectedPlayerData: null });
    });

    socket.on("livePlayerBidUpdate", (data) => {
      console.log("📥 Received: livePlayerBidUpdate", data);
      useAuthStore.setState({ liveBidData: data });
    });

    socket.on("clearLiveBidData", () => {
      // console.log("📥 Received: clearSelectedPlayerData");
      useAuthStore.setState({ liveBidData: null });
    });

    // squad list
    socket.on("liveTeamDetails", (id) => {
      useAuthStore.setState({ liveTeamId: id });
    });
  
    socket.on("clearLiveTeamId", () => {
      useAuthStore.setState({ liveTeamId: null });
    });

    return () => {
      socket.off("teamDetailsTrigger");
      socket.off("selectedPlayerData");
      socket.off("clearSelectedPlayerData");
      socket.off("livePlayerBidUpdate");
      socket.off("clearLiveBidData");
      socket.off("liveTeamDetails");
      socket.off("clearLiveTeamId");
    };
  }, []);
  return null;
};

export default SocketSync;
